/* Shared loading of team group data (Select/TeamsAndGroups).
 *
 * The sidebar (TeamSelector), NCAOverlay (via state.team.teamGroupLookup)
 * and Settings all depend on the same team -> group mapping, so anything
 * that changes groups or assignments calls loadTeamGroups afterwards to keep
 * app state in step without a page reload.
 */

/* Key for teams that aren't in any group. Matches the API, which keys
 * ungrouped teams under "0"; real GroupIDs are always positive. */
export const UNGROUPED_KEY = 0;
export const UNGROUPED_TITLE = 'Ungrouped';

/**
 * Loads team groups and dispatches { team: { Groups, teamGroupLookup } },
 * where teamGroupLookup maps TeamID -> { GroupID, GroupTitle } (GroupID is
 * null for ungrouped teams).
 * @returns {Promise} resolving to { Groups, teams } where teams is the flat
 * list of { TeamID, TeamName, GroupID, GroupTitle }
 */
export const loadTeamGroups = (api, eventDispatch) =>
    api.transact('TeamsAndGroupsList', {})
        .then(r => r.apiResult)
        .then(apiResult => {

            const Groups = apiResult.Groups || [];
            const teams = Object.values(apiResult.Teams || {}).flat();

            const teamGroupLookup = {};
            teams.forEach(t => {
                teamGroupLookup[t.TeamID] = {
                    GroupID: t.GroupID ?? null,
                    GroupTitle: t.GroupTitle ?? null
                };
            });

            eventDispatch({ team: { Groups, teamGroupLookup } });

            return { Groups, teams };
        });
